import { useDecision } from '@optimizely/react-sdk';

const FEATURE_FLAG_NAME = 'qantas-hotels-expt_4-member_deals_sash';
const VARIATION_KEY = 'show_red_sash';

type Result = {
  isReady: boolean;
  showRedSash: boolean;
};

const useShowRedSashToggle = ({ promotionName }: { promotionName: string }): Result => {
  const [decision, isReady] = useDecision(FEATURE_FLAG_NAME, { autoUpdate: true });

  return {
    isReady,
    showRedSash: decision.enabled && decision.variationKey === VARIATION_KEY && promotionName?.toLowerCase() === 'member deal',
  };
};

export default useShowRedSashToggle;
